<template>
  <div class="results">
    <div class="results-wrap">
      <div class="results-content">
        <ListSider ref="sidebar" class="r-sidebar" :style="`min-height:${sidebarMinHeight}`" :keyword.sync="keyword" :categoryID.sync="categoryID" :timeStr.sync="timeStr"></ListSider>
        <ListContent ref="content" class="r-main" :dataSet="dataSet" :pageSize="pageSize" :isShowLoader="isShowLoader"></ListContent>
      </div>
    </div>
  </div>
</template>

<script>
import ListSider from './ListSider'
import ListContent from './ListContent'

export default {
  name: 'NewsList',
  components: { ListSider, ListContent },
  data () {
    return {
      sidebarMinHeight: 0,
      isShowLoader: false,
      pageSize: 12,
      dataSet: {},
      keyword: '',
      categoryID: -1,
      timeStr: '',
      startTime: 0,
      endTime: 0
    }
  },
  watch: {
    keyword (newVal, oldVal) {
      if (newVal !== oldVal) {
        this.getData(1)
      }
    },
    categoryID (newVal, oldVal) {
      if (newVal !== oldVal) {
        this.getData(1)
      }
    },
    timeStr (newVal, oldVal) {
      if (newVal !== oldVal) {
        if (this._.isEmpty(newVal)) {
          this.startTime = 0
          this.endTime = 0
        } else {
          let tmp = this._.split(newVal, '|')
          this.startTime = parseInt(tmp[0]) || 0
          this.endTime = parseInt(tmp[1]) || 0
        }
        this.getData(1)
      }
    }
  },
  created () {
    this.requestData({page: 1, size: this.pageSize, key: this.$route.query.k || ''})
  },
  mounted () {
    this.$nextTick(() => {
      this.setSidebarHeight()
    })
  },
  methods: {
    getData (page) {

      page = page || 1
      let key = this._.trim(this.keyword || '')
      let cid = !this.categoryID || this.categoryID === -1 ? '' : this.categoryID
      let startT = this.startTime && this.startTime !== 0 ? this.startTime : ''
      let endT = this.endTime && this.endTime !== 0 ? this.endTime : ''
      this.requestData(this._.assign({page: page}, {size: this.pageSize, key: key, categoryId: cid, startTime: startT, endTime: endT}))
    },
    delayRequestData (data) {
      setTimeout(() => {
        this.requestData(data)
      }, 500)
    },
    requestData (data) {
      if (this.isShowLoader) {
        this.delayRequestData()
        return
      }
      this.$Loading.start()
      this._h.scrollTop()
      this.isShowLoader = true
      this.$api.news.getList(data, {
        success: (response) => {
          this.$Loading.finish()
          if (response.data.code === 200) {
            if (!this._.isEmpty(response.data.data)) {
              if (this.$refs.content) {
                this.$refs.content.currentPage = data.page || 1
              }
              this.dataSet = response.data.data
              setTimeout(() => {
                this.setSidebarHeight()
              }, 500)
            } else {
              this.$Message.warning({content: this.$t('query.message.news_none'), closable: true})
            }
          } else if (response.data.code === 404) {
            this.$Message.warning({content: this.$t('query.message.news_none'), closable: true})
          } else {
            this.$Message.warning({content: response.data.message, closable: true})
          }
          this.isShowLoader = false
        },
        error: (errorMsg) => {
          this.isShowLoader = false
          this.$Message.error({content: this.$t('common.tryAgain'), closable: true})
          this.$Loading.error()
        }
      })
    },
    setSidebarHeight () {
      let resultDom = document.querySelector('.results')
      let breadcrumb = document.querySelector('.ivu-breadcrumb')
      let footer = document.querySelector('footer')
      let sidebarHeight = this._h.getOuterElSize(this.$refs.sidebar.$el).height
      let contentHeight = this._h.getOuterElSize(this.$refs.content.$el).height
      let resultMinHeight = (this._h.getWinHeight() - Math.abs(this._h.getScrollTop() - Math.abs(this._h.getOffset(resultDom).top) - this._h.getOuterElSize(footer).height - 18))
      let _sidebarHeight = resultMinHeight - this._h.getOuterElSize(breadcrumb).height - this._h.getOuterElSize(resultDom)['paddingHeight']
      if (sidebarHeight > _sidebarHeight) {
        resultMinHeight += sidebarHeight - _sidebarHeight
        _sidebarHeight = sidebarHeight
      }
      if (contentHeight < sidebarHeight || contentHeight < _sidebarHeight) {
        this.sidebarMinHeight = `${_sidebarHeight}px`
      } else {
        this.sidebarMinHeight = '100%'
      }
      resultDom.style.minHeight = resultMinHeight + 'px'
    }
  }
}
</script>
<style scoped>
  .results{
    position: relative;
    padding: 15px 0 25px;
  }
  .results-wrap{
    width:1400px;
    margin: 0 auto;
    padding-bottom: 20px;

  }
  .shadow-divide{
    position: absolute;
    top:0;
    left:0;
    width: 100%;
    box-shadow: 0 2px 4px 0 rgba(223,223,223,0.50);
    z-index: 1;
    height: 5px;
    background-color: #fff;
  }
  .ivu-breadcrumb{
    margin: 12px 0 30px;
    /*font-size: 11px;*/
    font-size: 13px;
  }
  .ivu-breadcrumb .ivu-breadcrumb-item-link,
  .ivu-breadcrumb >>> a{
    color: #999;
  }
  .ivu-breadcrumb >>> a:hover{
    color: #1F8AFD;
    text-decoration: none;
    box-shadow: none;
  }
  .ivu-breadcrumb >>> a:after{
    width: 0;
    height: 0;
  }
  .ivu-breadcrumb > span:last-child{
    color: #1F8AFD;
    font-weight: normal;
  }
  .ivu-breadcrumb >>> .ivu-breadcrumb-item-separator{
    margin: 0 2px;
  }
  .results-content{
    position: relative;
    padding-left: 290px;
  }
  .r-main{}
  .r-sidebar{
    position: absolute;
    top:0;
    left: 0;
    width: 260px;
    min-height: 100%;
    background-color: #fff;
  }
</style>



// WEBPACK FOOTER //
// src/components/news/List.vue